var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Ficha",
    transform: "translate(-1632.000000, -727.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1642.1,742 C1645.6,742 1647,740.6 1647,737.1 L1647,732.9 C1647,729.4 1645.6,728 1642.1,728 L1637.9,728 C1634.4,728 1633,729.4 1633,732.9 L1633,737.1 C1633,740.6 1634.4,742 1637.9,742 L1642.1,742 Z M1639.99615,737.8 L1639.99615,734.3 M1640,732.2 L1639.9,732.2",
    id: "info"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f26e0da3b25372bcfa51c13f31c14aff.svg";
export { ForwardRef as ReactComponent };